import React, { useEffect } from 'react';

const SourceForgeBadge = () => {

    useEffect(() => {
        // Create and append the script element
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://b.sf-syn.com/badge_js?sf_id=3573631&variant_id=sf';
        document.head.appendChild(script);

        // Clean up the script element when the component is unmounted
        return () => {
            document.head.removeChild(script);
        };
    }, []); // The empty array as the second argument ensures this effect runs only on mount and unmount
    return (
        <div className="sf-root" data-id="3573631" data-badge="light-default" data-variant-id="sf" style={{ width: '75px' }}>
            <a href="https://sourceforge.net/software/product/Pdftools/" target="_blank">Pdftools Reviews</a>
        </div>
    );
}

export default SourceForgeBadge;